import createAxiosInstance from './createAxiosInstance'

const path = process.env.VUE_APP_HOUSEKEEPER_API
const instance = createAxiosInstance(`${path}/api/v1`)

export const apiOrderFood = {
  /**
   * 取得餐點類別
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/get_api_v1_TableFoodMenu
   */
  getFoodMenu: () => instance.get('/TableFoodMenu'),
  /**
   * 新增餐點類別
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/post_api_v1_TableFoodMenu
   */
  addFoodMenu: (data) => instance.post('/TableFoodMenu', data),
  /**
   * 更新餐點類別
   * @param {*} id 類別ID
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/put_api_v1_TableFoodMenu__Id_
   */
  updateFoodMenu: (id, data) => instance.put(`/TableFoodMenu/${id}`, data),
  /**
   * 更新餐點類別排序
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/put_api_v1_TableFoodMenu_Sequence
   */
  updateFoodMenuSequence: (data) => instance.put('/TableFoodMenu/Sequence', data),
  /**
   * 刪除餐點類別
   * @param {*} id 類別ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodMenu/delete_api_v1_TableFoodMenu__Id_
   */
  deleteFoodMenu: (id) => instance.delete(`/TableFoodMenu/${id}`),
  /**
   * 取得規格列表
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/get_api_v1_TableFoodSpec
   */
  getFoodSpec: () => instance.get('/TableFoodSpec'),
  /**
   * 新增規格
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/post_api_v1_TableFoodSpec
   */
  addFoodSpec: (data) => instance.post('/TableFoodSpec', data),
  /**
   * 更新規格
   * @param {*} id 規格ID
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/put_api_v1_TableFoodSpec__Id_
   */
  updateFoodSpec: (id, data) => instance.put(`/TableFoodSpec/${id}`, data),
  /**
   * 更新規格排序
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/put_api_v1_TableFoodSpec_Sequence
   */
  updateFoodSpecSequence: (data) => instance.put('/TableFoodSpec/Sequence', data),
  /**
   * 刪除規格
   * @param {*} id 規格ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/delete_api_v1_TableFoodSpec__Id_
   */
  deleteFoodSpec: (id) => instance.delete(`/TableFoodSpec/${id}`),
  /**
   * 查詢使用特定規格的項目
   * @param {*} id 規格ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodSpec/get_api_v1_TableFoodSpec__Id__Used_Items
   */
  getFoodSpecUsedItems: (id) => instance.get(`/TableFoodSpec/${id}/Used-Items`),
  /**
   * 已取得之餐桌美食表單列表（已完成訂單）
   * @param {*} params 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/get_api_v1_TableFood_Form_Successfuls
   */
  getTableFoodFormSuccessfuls: (params) => instance.get('/TableFood/Form/Successfuls', { params }),
  /**
   * 已取消或已作廢之餐桌美食表單列表
   * @param {*} params 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/get_api_v1_TableFood_Form_CanceledAndVoid
   */
  getTableFoodFormCanceledAndVoid: (params) => instance.get('/TableFood/Form/CanceledAndVoid', { params }),
  /**
   * 取得訂單詳細資料 V3
   * @param {string} id 訂單識別碼
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/get_api_v1_TableFood_Form__id_
   */
  getTableFoodFormDetail: (id) => instance.get(`/TableFood/Form/${id}`),
  /**
   * 新增餐桌美食表單(新版單一支付)
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/post_api_v1_TableFood_Form_Single
   */
  addFoodFormSingleV3: (data) => instance.post('/TableFood/Form/Single', data),
  /**
   * 新增餐桌美食表單(新版混合支付)
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/post_api_v1_TableFood_Form_Mode
   */
  addFoodFormModeV3: (data) => instance.post('/TableFood/Form/Mode', data),
  /**
   * 匯出已完成餐桌美食表單
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/post_api_v1_TableFood_Form_Successfuls_Export
   */
  exportTableFoodFormSuccessfuls: (data) => instance.post('/TableFood/Form/Successfuls/Export', data),
  /**
   * 匯出已取消與已作廢餐桌美食表單
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/post_api_v1_TableFood_Form_CanceledAndVoid_Export
   */
  exportTableFoodFormCanceledAndVoid: (data) => instance.post('/TableFood/Form/CanceledAndVoid/Export', data),
  /**
   * 作廢訂單 V3
   * @param {string} id 訂單識別碼
   * @param {{ Note: string }} data 作廢備註
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/patch_api_v1_TableFood_Form__id_
   */
  voidTableFoodForm: (id, data) => instance.patch(`/TableFood/Form/${id}`, data),
  /**
   * 餐桌美食菜單匯出存儲-取得已完成可下載入數量
   * @param {*} params 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodExportStorage/get_api_v1_TableFoodExportStorage_Completed_And_Downloadable
   */
  getCompletedAndDownloadable: (params) => instance.get('/TableFoodExportStorage/Completed-And-Downloadable', { params }),
  /**
   * 餐桌美食菜單匯出存儲-取得列表
   * @param {*} params 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodExportStorage/get_api_v1_TableFoodExportStorage
   */
  getTableFoodExportStorageList: (params) => instance.get('/TableFoodExportStorage', { params }),
  /**
   * 餐桌美食菜單匯出存儲-申請匯出
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodExportStorage/post_api_v1_TableFoodExportStorage
   */
  postTableFoodExportStorage: (data) => instance.post('/TableFoodExportStorage', data),
  /**
   * 餐桌美食菜單匯出存儲-下載網址加密
   * @param {string} id 資料ID
   * @param {*} config 設定
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFoodExportStorage/get_api_v1_TableFoodExportStorage__Id__Url_Signer
   */
  downloadTableFoodExportStorage: (id, config) => instance.get(`/TableFoodExportStorage/${id}/Url-Signer`, Object.assign({}, config)),
  /**
   * 取得社區開通點數類型
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/Point/get_api_v1_Point_Point_Type
   */
  getPointType: () => instance.get('/Point/Point-Type'),
  /**
   * 取得社區戶別-手機條碼
   * @param {string} deviceSn 手機條碼
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/CommunityTablet/get_api_v1_CommunityTablet__DeviceSn__Device
   */
  getCommunityTabletsByPhone: (deviceSn) => instance.get(`CommunityTablet/${deviceSn}/Device`),
  /**
   * 取得社區戶別-載具(門禁卡、磁扣)
   * @param {string} code 代碼
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/CommunityTablet/get_api_v1_CommunityTablet__Code__Carrier
   */
  getCommunityTabletsByCarrier: (code) => instance.get(`CommunityTablet/${code}/Carrier`),
  /**
   * 點數-用戶查詢點數
   * @param {string} tabletId 戶別ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/Point/get_api_v1_Point__TabletId__Points
   */
  getCommunityTabletPoints: (tabletId) => instance.get(`Point/${tabletId}/Points`),
  /**
   * 取得會館資訊（營業時間、休息日、桌號）
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/get_api_v1_TableFood_Clubhouse_Info
   */
  getClubhouseInfo: (config) => instance.get('/TableFood/Clubhouse/Info', config),
  /**
   * 儲存會館營業時間與休息日
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/post_api_v1_TableFood_Clubhouse_Business_And_Holiday
   */
  saveClubhouseBusinessAndHoliday: (data) => instance.post('/TableFood/Clubhouse/Business-And-Holiday', data),
  /**
   * 儲存出單設定（整筆覆蓋，兩個欄位都必須送出）
   * @param {Object} data 參數資料
   * @param {number} data.NormalFormPrintCount 訂單出單張數（0～6，0 表示不出單）
   * @param {number} data.AbnormalFormPrintCount 異常出單張數（拒單／取消／作廢，0～6，0 表示不出單）
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/post_api_v1_TableFood_Clubhouse_Print_Setting
   */
  saveClubhousePrintSetting: (data) => instance.post('/TableFood/Clubhouse/Print-Setting', data),
  /**
   * 新增內用桌號
   * @param {*} data 參數資料
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/post_api_v1_TableFood_Clubhouse_Table
   */
  addClubhouseTableNo: (data) => instance.post('/TableFood/Clubhouse/Table', data),
  /**
   * 刪除內用桌號
   * @param {string} id 桌號ID
   * Swagger: https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/TableFood/delete_api_v1_TableFood_Clubhouse_Table__Id_
   */
  deleteClubhouseTableNo: (id) => instance.delete(`/TableFood/Clubhouse/Table/${id}`),
  /**
   * 線上訂單 - 尚未接單列表
   * @param {*} params 參數資料
   */
  getTableFoodFormOrderPending: (params) => instance.get('/TableFood/Form/Order/Pending', { params }),
  /**
   * 線上訂單 - 餐點準備中列表
   * @param {*} params 參數資料
   */
  getTableFoodFormMealPending: (params) => instance.get('/TableFood/Form/Meal/Pending', { params }),
  /**
   * 線上訂單 - 接單
   * @param {string} id 訂單識別碼
   * @param {*} data 參數資料
   */
  acceptTableFoodFormOrder: (id, data) => instance.patch(`/TableFood/Form/Order/${id}/Accepted`, data),
  /**
   * 線上訂單 - 拒單
   * @param {string} id 訂單識別碼
   * @param {*} data 參數資料
   */
  cancelTableFoodFormOrder: (id, data) => instance.patch(`/TableFood/Form/Order/${id}/Canceled`, data),
  /**
   * 線上訂單 - 通知取餐
   * @param {string} id 訂單識別碼
   * @param {*} data 參數資料
   */
  notifyTableFoodFormMealReady: (id, data) => instance.patch(`/TableFood/Form/Meal/${id}/Ready`, data),
  /**
   * 線上訂單 - 準備中作廢
   * @param {string} id 訂單識別碼
   * @param {*} data 參數資料
   */
  cancelTableFoodFormMeal: (id, data) => instance.patch(`/TableFood/Form/Meal/${id}/Canceled`, data),
  /**
   * 線上訂單 - 待取餐列表
   * @param {*} params 參數資料
   */
  getTableFoodFormPickupPending: (params) => instance.get('/TableFood/Form/Pickup/Pending', { params }),
  /**
   * 線上訂單 - 完成取餐
   * @param {*} data 參數資料 { Ids, PickupType, PickupId, Note }
   */
  completeTableFoodFormPickup: (data) => instance.post('/TableFood/Form/Pickup/Completed', data),
  /**
   * 線上訂單 - 待取餐通知取餐
   * @param {string} id 訂單識別碼
   */
  notifyTableFoodFormPickup: (id) => instance.get(`/TableFood/Form/Pickup/${id}/Notification`)
}
